import React from 'react';
import { Navigate } from 'react-router-dom';
import { canManageUsers } from '../../constants/permissions';

const PermissionRoute = ({ children }) => {
  if (!canManageUsers()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PermissionRoute;
